<template>
    <div class="modifyAccount">
        <el-dialog
            title="修改结算账户信息"
            :visible.sync="dialogVisibleAccount"
            :close-on-click-modal="false"
            @close="resetForm"
            width="800px"
        >
            <div class="dialogBoxClass">
                <el-form
                    :model="form"
                    :rules="rules"
                    ref="ruleForm"
                    label-width="150px"
                    class="demo-ruleForm"
                >
                    <el-form-item label="结算方向" prop="settleWay">
                        <el-select
                            v-model="form.settleWay"
                            clearable
                            placeholder="请选择结算方向"
                        >
                            <el-option label="结算至资金账户" value="ACCOUNT"></el-option>
                            <el-option
                                label="结算至银行卡"
                                value="BANKCARD"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        class="bankChange"
                        label="请选择结算银行卡"
                        prop="cardUuid"
                        v-if="form.settleWay == 'BANKCARD'"
                    >
                        <el-radio-group v-model="form.cardUuid">
                            <el-radio
                                :label="items.uuid"
                                v-for="items in bankClass"
                                :key="items.uuid"
                            >
                                <p>{{ items.bankCardTypeCn }}</p>
                                <p>{{ items.bankName }}</p>
                                <p>{{ items.shotCardNo }}</p>
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item class="submitButtonGroup">
                        <el-button @click="dialogVisibleAccount = false">取消</el-button>
                        <el-button type="primary" @click="submitForm">确认</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {listSettledCard,changeSettleWay} from "../../utils/interface";

export default {
    name: "modifyAccount",
    data() {
        return {
            dialogVisibleAccount: false,
            title: "",
            form: {
                settleWay: "",
                cardUuid: "",
            },
            rules: {
                settleWay: [
                    {required: true, message: "请选择结算方向", trigger: "blur"},
                ],
                cardUuid: [
                    { required: true, message: "请选择结算银行卡", trigger: "blur" },
                ],
            },
            bankClass: []
        };
    },
    inject: ['searchSettleCard'],
    methods: {
        init() {
            this.dialogVisibleAccount = true;
            listSettledCard().then(resp=>{
                this.bankClass = resp;
            })
        },
        resetForm(){
            this.$refs.ruleForm.resetFields();
        },
        submitForm() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    changeSettleWay(this.form).then(resp=>{
                        if (resp.success) {
                            this.resetForm();
                            this.$message.success("修改成功");
                            this.dialogVisibleAccount = false;
                            this.searchSettleCard();
                        } else {
                            this.$message.error(resp.message);
                        }
                    });
                } else {
                    this.$message.error("请填写完整信息");
                }
            });
        },
    },
};
</script>

<style lang="less" scoped>
.bankChange {
    display: flex;
    flex-direction: column;

    /deep/ .el-form-item__content {
        margin-left: 27px !important;
    }

    /deep/ .el-radio-group {
        display: flex;
        flex-wrap: wrap;
    }

    /deep/ .el-radio {
        display: flex;
        margin-bottom: 20px;

        p {
            margin: 0;
            margin-bottom: 10px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/balance/modifyAccount.vue